/**
 * SSO 戻り先 URL の検証（ログイン・登録で共用）。
 * 他の Genemo アプリ（genemo.jp / *.genemo.jp・https）だけ許可し、オープンリダイレクトを防ぐ。
 * サーバー側 routes/auth.ts の safeReturnUrl と同じ規則。許可されない場合は空文字。
 */
export function parseReturnUrl(raw: string | null): string {
  if (!raw) return ''
  try {
    const u = new URL(raw)
    if (u.protocol === 'https:' && (u.hostname === 'genemo.jp' || u.hostname.endsWith('.genemo.jp'))) return u.toString()
  } catch { /* ignore */ }
  return ''
}
